
import { Component, OnInit } from '@angular/core';
import { AddCategoryComponent } from '../add-category/add-category.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

import { CategoryService, ToasterService } from '../../_services/';

import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {
  public categoryList:any[];
  constructor(
    private dialog : MatDialog,
    private spinner: NgxSpinnerService,
    private _category : CategoryService,
    private _toaster: ToasterService
  ) { }

  ngOnInit(): void {
    this.getCategoryList()
  }


  getCategoryList(){
    this.spinner.show();
    this._category.getCategoryList().subscribe(result=>{
      this.categoryList = result;
      this.spinner.hide();
    },err=>{
      alert("Something went wrong");
    })
  }

  addCategory(){
    this.dialog.open(AddCategoryComponent, {
      width: 'auto',
    });
  }

  editCategory(id, name){
    this.dialog.open(AddCategoryComponent, {
      width: 'auto',
      data: {
        id : id,
        name : name
      }
    });
  }


  deleteCategory(id){
    this.spinner.show();
    // Check if any product exists inside this category...
    this._category.fetchCategoryProducts(id).subscribe(result=>{
      if(result.length==0){
        this._category.deleteCategory(id).then(result=>{
          this.spinner.hide();
          this._toaster.showSuccess("Category deleted successfully!", "Success");
        }).catch(err=>{
          alert("Something went wrong");
        })
      }
      else {
        this.spinner.hide();
        this._toaster.showError("You first have to remove products from this category before it can be deleted.", "Error");
      }
    },err=>{
      this.spinner.hide();
      this._toaster.showError("Something went wrong.", "Error");
    })
    
  }

}
